/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentSettingCreateRequest
 */
export interface IncidentSettingCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof IncidentSettingCreateRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IncidentSettingCreateRequest
     */
    priority?: number;
}

/**
 * Check if a given object implements the IncidentSettingCreateRequest interface.
 */
export function instanceOfIncidentSettingCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function IncidentSettingCreateRequestFromJSON(json: any): IncidentSettingCreateRequest {
    return IncidentSettingCreateRequestFromJSONTyped(json, false);
}

export function IncidentSettingCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentSettingCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
    };
}

export function IncidentSettingCreateRequestToJSON(value?: IncidentSettingCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'priority': value.priority,
    };
}

